import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { Auth } from '@angular/fire/auth'; // Ou ton service d'auth habituel
import { map } from 'rxjs';
import { authState } from '@angular/fire/auth';

export const globalAuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const auth = inject(Auth);

  if (!environment.requireAuthGlobal) {
    return true;
  }

  if (state.url === '/login') {
    return true;
  }

  return authState(auth).pipe(
    map((user) => {
      if (user) {
        return true;
      } else {
        // Redirection vers le login avec l'URL de retour en paramètre
        return router.createUrlTree(['/login'], {
          queryParams: { returnUrl: state.url },
        });
      }
    }),
  );
};
